import React from 'react'
import {
  Button,
  Icon,
  Popup,
  Responsive
} from 'semantic-ui-react'
// Local
import { CONDITION } from '../../../constant'
import If from '../../common/if'
import { EncounterConditionDisplay } from '../../authenticated/types'

/**
 * Provides a component that renders a condition header toolbar for CDI users
 * The toolbar provides buttons for changing the condition code and status
 * @param condition Condition entity
 * @param onClick Callback for toolbar button click
 *        Arguments: action, condition
 */

type Props = {
  condition: EncounterConditionDisplay
  onClick: (
    action: any,
    condition: EncounterConditionDisplay
  ) => void
}

function CdiConditionHeaderToolbar(
  props: Props
) {
  const {
    condition: conditionProp,
    onClick: onClickProp
  } = props

  const onClick = (
    e: any,
    action: any
  ) => {
    e.stopPropagation()
    onClickProp(
      action,
      conditionProp
    )
  }

  const condition = conditionProp
  const actions = CONDITION.ACTION
  return (
    <span>
      <If isTrue={ condition.conditionCode === CONDITION.CODE.REMOVED }>
        <span>
          <Popup
            content="Mark as Active"
            mouseEnterDelay={ 1000 }
            trigger={
              <Responsive
                as={ Button }
                icon
                basic
                size="mini"
                onClick={
                  (e: any) => {
                    onClick(e, actions.MARK_OPEN)
                  }
                }
              >
                <Icon name="undo" />
              </Responsive>
            }
          />
        </span>
      </If>
      <If isTrue={
        condition.conditionCode !== CONDITION.CODE.REMOVED &&
        condition.conditionCode !== CONDITION.CODE.DISMISSED &&
        condition.conditionStatus === CONDITION.TYPE.POTENTIAL
      }
      >
        <span>
          <Popup
            content="Mark as Removed"
            mouseEnterDelay={ 1000 }
            trigger={
              <Responsive
                as={ Button }
                icon
                basic
                size="mini"
                onClick={
                  (e: any) => {
                    onClick(e, actions.MARK_REMOVED)
                  }
                }
              >
                <Icon name="trash alternate outline" />
              </Responsive>
            }
          />
        </span>

      </If>
      <If isTrue={
        condition.conditionCode !== CONDITION.CODE.REMOVED &&
        condition.conditionCode !== CONDITION.CODE.DISMISSED &&
        condition.conditionStatus === CONDITION.TYPE.ACTIVITY
      }
      >
        <span>
          <Popup
            content="Mark as Removed"
            mouseEnterDelay={ 1000 }
            trigger={
              <Responsive
                as={ Button }
                icon
                basic
                size="mini"
                onClick={
                  (e: any) => {
                    onClick(e, actions.MARK_REMOVED)
                  }
                }
              >
                <Icon name="trash alternate outline" />
              </Responsive>
            }
          />
        </span>
      </If>
      <If isTrue={
        condition.conditionCode !== CONDITION.CODE.REMOVED &&
        condition.conditionCode !== CONDITION.CODE.DISMISSED &&
        condition.conditionStatus === CONDITION.TYPE.KNOWN
      }
      >
        <span>
          <Popup
            content="Mark as Removed"
            mouseEnterDelay={ 1000 }
            trigger={
              <Responsive
                as={ Button }
                icon
                basic
                size="mini"
                onClick={
                  (e: any) => {
                    onClick(e, actions.MARK_REMOVED)

                  }
                }
              >
                <Icon name="trash alternate outline" />
              </Responsive>
            }
          />
        </span>
      </If>
    </span>
  )
}

export default CdiConditionHeaderToolbar
